/**
 * Created by Administrator on 2017/8/11 0011.
 */

function getUrlSearchParams(obj) {
  let formData = new FormData();
  Object.keys(obj).forEach(key => {
    formData.append(key, obj[key]);
  });
  return formData;
}

function buildQuery(params) {
    let paramsArray = [];
    Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]));
    return '?' + paramsArray.join('&');
}

export {getUrlSearchParams, buildQuery};

